import { NewExclusionListBaseDataProvider } from './NewExclusionListBaseDataProvider';
import { NewExclusionListWebComponentSchema } from '../types';

export class NewExclusionListGzDataProvider extends NewExclusionListBaseDataProvider {
  async getDataForView(): Promise<NewExclusionListWebComponentSchema> {
    return {} as unknown as NewExclusionListWebComponentSchema;
  }
}
